import {Component} from '@angular/core';
import {kanUsersService} from "../../../../services/services/users";
import {User} from "../../../../../classes/user";
import {StateService} from "@uirouter/angular";

@Component({
    selector: 'kan-user',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanUser {
    public user: User;
    public userCopy: User;
    public mode: string = 'display';

    constructor(private stateService: StateService, private userService: kanUsersService) {
    }

    ngOnInit(): void {
        this.getUser();
    }

    public getUser(): void {
        this.userService.getUserById(this.stateService.params.id)
            .then((user: User) => {
                this.user = user;
            })
            .catch((error) => {
                console.log(error);
            });
    }

    public goBack(event: any): void {
        this.stateService.go('app.admin');
    }

    public edit(event: any): void {
        this.userCopy = Object.assign({}, this.user)
        this.mode = 'edit';
    }

    public cancel(event: any): void {
        this.mode = 'display';
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/user/user/component.ts